const aws_region = "us-east-1";

const config = {
  appName: "Cash Sweep UI - Sandbox",
  region: aws_region,
  cognito: {
    userPoolId: `${aws_region}_Er7UorY60`,
    domain: `pgi-cashsweep-domain-dev.auth.${aws_region}.amazoncognito.com`,
    tokenUrl: `https://pgi-cashsweep-domain-dev.auth.${aws_region}.amazoncognito.com/oauth2/authorize`,
    providerId: "pgi-cashsweep-identity-provider",
    redirectUrl: "https://www.gmmcashsweep.fundaccounting.dev.principal.com",
    clientId: "4fa8phcgtpklqq9i2gadkpjiq6",
    scope: "pgi-cashsweep-resource-server/read-write",
    updateGroup: "pgi-cashsweep-read-write-client",
  },
  api: {
    baseUrl: `https://wbtfibup7e.execute-api.us-east-1.amazonaws.com/prod/api/v1`,
  },
};

export default config;
